import {
  endDateAfterStartDateIfEndType,
  integerIfEndType,
  minValueIfEndType,
  requiredIfEndType,
  requiredIfScheduleType,
} from "@/utils/validationRules";
import { PaymentEndCondition, PaymentFrequency } from "@/api/generated/graphql";

export enum PaymentScheduleType {
  Now = "Now",
  Later = "Later",
  Recurring = "Recurring",
}

export interface ScheduledPaymentForm {
  scheduleType: PaymentScheduleType;
  frequency: PaymentFrequency;
  startDate?: Date | null;
  endDate?: Date | null;
  endCount?: number | null;
  endType: PaymentEndCondition;
}

export function scheduledPaymentFormDefaultState(): ScheduledPaymentForm {
  return {
    scheduleType: PaymentScheduleType.Now,
    frequency: PaymentFrequency.OneOff,
    startDate: null,
    endDate: null,
    endCount: null,
    endType: PaymentEndCondition.OnDate,
  };
}
export const scheduledPaymentFormValidations = () => ({
  scheduleType: {},
  startDate: { required: requiredIfScheduleType([PaymentScheduleType.Later, PaymentScheduleType.Recurring]) },
  frequency: { required: requiredIfScheduleType([PaymentScheduleType.Recurring]) },
  endType: {},
  endDate: {
    required: requiredIfEndType(PaymentEndCondition.OnDate),
    afterStartDate: endDateAfterStartDateIfEndType(PaymentEndCondition.OnDate),
  },
  endCount: {
    required: requiredIfEndType(PaymentEndCondition.AfterCount),
    integer: integerIfEndType(PaymentEndCondition.AfterCount),
    minValue: minValueIfEndType(1, PaymentEndCondition.AfterCount),
  },
});
